import { StatusColorType } from "@/components/atoms/Status/styled";
import { TableColumProps } from "@/components/molecules";
import { fakeI18n } from "@/i18n";
import { Document, DocumentsSortProperty } from "@/shared/domain";

export const StatusColorMap = {
    Signed: StatusColorType.Success,
    Refused: StatusColorType.Error,
};

export const documentTableColumnsDesktop: TableColumProps<Document, DocumentsSortProperty>[] = [
    {
        sortableKey: "description",
        label: fakeI18n.t("Common.Title"),
        width: 35,
    },
    {
        unsortableKey: "secondaryDescription",
        label: fakeI18n.t("Common.Description"),
        notSortable: true,
        width: 25,
    },
    {
        sortableKey: "fileSize",
        label: fakeI18n.t("Documents.Label.Size"),
        width: 20,
    },
    {
        sortableKey: "date",
        label: fakeI18n.t("Common.Date"),
        width: 15,
    },
    {
        unsortableKey: "status.id",
        label: fakeI18n.t("Documents.Label.Status"),
        notSortable: true,
        width: 15,
    },
];

export const documentTableColumnsMobile: TableColumProps<Document, DocumentsSortProperty>[] = [
    {
        unsortableKey: "status.id",
        label: fakeI18n.t("Documents.Label.Status"),
        notSortable: true,
        width: 100,
    },
];
